export const getQueryOptions = ({
  databaseFieldId,
  start,
  maxTotalNumberOfItems = undefined,
  collectionFilters = [],
}) => ({
  limit: maxTotalNumberOfItems,
  filters: [
    ...collectionFilters,
    {
      column: databaseFieldId,
      value: { range: [start] },
      type: "DATE",
      condition: "IS",
    },
    {
      isMultiUser: true,
      type: "BOOLEAN",
      value: true,
      column: "hidden",
      condition: "NOT",
    },
  ],
  sort: { fieldId: databaseFieldId, order: "desc", fieldPrefix: "date_field" },
});
